import * as React from 'react';
import { handleError } from '../../../../shared/ErrorCatching';
import { Col, Checkbox, FormGroup, ControlLabel } from 'react-bootstrap';
import { Translate } from '../../../../shared/LanguageService';
import * as Actions from './Actions';
import { connect } from 'react-redux';
import * as Features from '../../../../shared/Features';
import FormSelect from '../../../../components/common/FormSelect';
import { ICopywriter } from '../../../copywriters/Entities';
import notify from '../../../../shared/feedback/notifications';

class TextHandling extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {};
    }

    componentDidMount(): void {
        this.props.actions
            .getTextInfo(this.props.orderId)
            .catch((error: any) => handleError(error));
        
        this.props.actions
            .getAvailableCopywriters(this.props.orderId)
            .catch((error: any) => handleError(error));
    }

    setIfTextIsDelivered = () => {
        if (this.props.text && this.props.text.textDeliveredTimeLocal) {
            this.props.actions
                .setTextAsNotDelivered(this.props.orderId)
                .catch((error: any) => handleError(error));
        } else {
            this.props.actions
                .setTextAsDelivered(this.props.orderId)
                .catch((error: any) => handleError(error));
        }
    };

    copywriterChange = (e:any) => {
        if (e.target.value > 0) {
            this.props.actions.setCopywriterOnOrder(this.props.orderId, e.target.value)
            .then(() => notify.success(Translate('view-order/copy-info/copywriter/selector/changed-copywriter')))
            .catch((error: any) => handleError(error));
        } else if (e.target.value === "") {
            this.props.actions.setCopywriterOnOrder(this.props.orderId, null)
            .then(() => notify.success(Translate('view-order/copy-info/copywriter/selector/copywriter-reset')))
            .catch((error: any) => handleError(error));
        }
    }

    getCurrectSelectedCopywriterId = () =>
    {
        return this.props.text && 
               this.props.text.selectedCopywriterId &&
               this.props.text.selectedCopywriterId > 0 ? 
                    this.props.text.selectedCopywriterId 
                        : 
                    -1
               ;
    }

    render() {
        return (
            <div>
                <Col md={6} lg={4}>
                    {Features.hasFeature(Features.ViewCopywriterOnOrder, this.props.user) ?
                        <FormGroup className="copywriter-select">
                            <ControlLabel>
                                {Translate('view-order/copy-info/copywriter/selector/header')}
                            </ControlLabel>
                            <hr className="text-handling" />
                            <FormSelect
                                name="copywriter"
                                value={this.getCurrectSelectedCopywriterId() as any}
                                onChange={this.copywriterChange}
                                defaultTranslateKey="view-order/copy-info/copywriter/selector/placeholder"
                                disabled={!Features.hasFeature(Features.ChangeCopywriterOnOrder, this.props.user)}
                            >
                                {this.props.availableCopywriters && this.props.availableCopywriters.map((copywriter: ICopywriter) => {
                                    return (
                                        <option key={copywriter.id} value={copywriter.id as any}>
                                            {copywriter.name}
                                        </option>
                                    );
                                })}
                            </FormSelect>
                        </FormGroup>
                        : null

                    }
                    {Features.hasFeature(Features.UpdateFilename, this.props.user) && (
                        <>
                            <strong>
                                {Translate('view-order/copy-info/delivery-status')}
                            </strong>
                            <hr className="text-handling" />
                            <Checkbox
                                name="showScheduledOrders"
                                checked={
                                    this.props.text ? !!this.props.text.textDeliveredTimeLocal : false
                                }
                                onChange={this.setIfTextIsDelivered}
                            >
                                <span>{Translate('view-order/copy-info/delivered-label')}</span>
                            </Checkbox>
                        </>
                    )}
                </Col>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            setTextAsDelivered: (id: number) => dispatch(Actions.setTextAsDelivered(id)),
            setTextAsNotDelivered: (id: number) => dispatch(Actions.setTextAsNotDelivered(id)),
            getTextInfo: (id: number) => dispatch(Actions.getTextInfo(id)),
            getAvailableCopywriters: (orderId: number) => dispatch(Actions.getAvailableCopywriters(orderId)),
            setCopywriterOnOrder: (orderId: number, copywriterId: number) => dispatch(Actions.setCopywriterOnOrder(orderId, copywriterId))
        }
    };
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        availableCopywriters: state.orderText.availableCopywriters,
        text: state.orderText.text,
        user: state.user
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TextHandling);
